/**
 * Floating Discuss: scroll-driven rotation and hover rotation.
 * Fades out when user is within 100px of the bottom of the page.
 * Only runs if .floating-discuss__scroll, .floating-discuss and .floating-discuss__hover exist.
 */
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

const FADE_THRESHOLD_PX = 100;

export function initFloatingDiscussScrollRotation() {
	const scrollEl = document.querySelector(".floating-discuss__scroll");
	const link = document.querySelector(".floating-discuss");
	const hoverEl = document.querySelector(".floating-discuss__hover");
	if (!scrollEl || !link || !hoverEl) return;

	gsap.to(scrollEl, {
		rotation: 360,
		ease: "none",
		scrollTrigger: {
			trigger: document.body,
			start: "top top",
			end: "bottom bottom",
			scrub: 2,
		},
	});

	// Fade out .floating-discuss when within 100px of the bottom of the page
	ScrollTrigger.create({
		trigger: document.body,
		start: "bottom bottom-=100px",
		end: "bottom top",
		onEnter: () => gsap.to(link, { opacity: 0, duration: 0.25, ease: "power2.out" }),
		onLeaveBack: () => gsap.to(link, { opacity: 1, duration: 0.25, ease: "power2.out" }),
	});

	// Initial state if already in the fade zone (e.g. short page or restored scroll)
	let lastNearBottom = null;
	const checkNearBottom = () => {
		const scrollBottom = window.scrollY + window.innerHeight;
		const threshold = document.documentElement.scrollHeight - FADE_THRESHOLD_PX;
		const nearBottom = scrollBottom >= threshold;
		lastNearBottom = nearBottom;
		gsap.set(link, { opacity: nearBottom ? 0 : 1 });
	};
	checkNearBottom();
	ScrollTrigger.addEventListener("refresh", checkNearBottom);

	function onScroll() {
		const scrollBottom = window.scrollY + window.innerHeight;
		const threshold = document.documentElement.scrollHeight - FADE_THRESHOLD_PX;
		const nearBottom = scrollBottom >= threshold;
		if (lastNearBottom === nearBottom) return;
		lastNearBottom = nearBottom;
		gsap.to(link, { opacity: nearBottom ? 0 : 1, duration: 0.25, ease: "power2.out" });
	}
	window.addEventListener("scroll", onScroll, { passive: true });

	let hoverTween = null;

	link.addEventListener("mouseenter", () => {
		if (hoverTween) hoverTween.kill();
		hoverTween = gsap.to(hoverEl, {
			rotation: "+=360",
			duration: 20,
			ease: "none",
			repeat: -1,
		});
		gsap.to(hoverEl, {
			scale: 1.12,
			boxShadow: "0 0 32px rgba(0, 204, 200, 0.35)",
			duration: 0.3,
			ease: "power2.out",
		});
	});

	link.addEventListener("mouseleave", () => {
		if (hoverTween) {
			hoverTween.kill();
			hoverTween = null;
		}
		gsap.to(hoverEl, {
			scale: 1,
			boxShadow: "0 0 0 transparent",
			duration: 0.3,
			ease: "power2.out",
		});
	});
}
